import { Link } from "react-router-dom";

const popularServices = [
  {
    title: "Rubbish Removal",
    price: "from £75",
    badge: "SAME-DAY",
    badgeStyle: "bg-cl-green text-white",
    href: "/rubbish-removal",
    image: "https://public.readdy.ai/ai/img_res/79786dc4-32c5-4385-865b-7e88c7062b2a.png",
    imageBg: "#6CC412",
  },
  {
    title: "Sofa Removal",
    price: "from £75",
    badge: "SAME-DAY",
    badgeStyle: "bg-cl-green text-white",
    href: "/sofa-removal",
    image: "https://public.readdy.ai/ai/img_res/edited_f547d9d29aecbbb892b0086ac3b98fcc_23f71a2d.jpg",
    imageBg: "#e8edf7",
  },
  {
    title: "House Clearance",
    price: "from £350",
    badge: "POPULAR",
    badgeStyle: "bg-cl-lime text-cl-dark",
    href: "/house-clearance",
    image: "https://cleario.uk/wp-content/uploads/services/house-clearance.png",
    imageBg: "#6CC412",
  },
  {
    title: "Garden Waste Removal",
    price: "from £85",
    badge: "SAME-DAY",
    badgeStyle: "bg-cl-green text-white",
    href: "/garden-waste-removal",
    image: "https://cleario.uk/wp-content/uploads/services/garden-waste.png",
    imageBg: "#f0fce4",
  },
  {
    title: "Builders Waste Removal",
    price: "from £140",
    badge: "SAME-DAY",
    badgeStyle: "bg-cl-green text-white",
    href: "/builders-waste-removal",
    image: "https://cleario.uk/wp-content/uploads/services/builders-waste.png",
    imageBg: "#e8edf7",
  },
  {
    title: "Man & Van Clearance",
    price: "from £85",
    badge: "SAME-DAY",
    badgeStyle: "bg-cl-green text-white",
    href: "/man-and-van-waste-clearance",
    image: "https://cleario.uk/wp-content/uploads/services/man-and-van.png",
    imageBg: "#e8edf7",
  },
];

export default function ContactServices() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-4 thick-border cartoon-shadow-sm">
            <i className="ri-service-line text-cl-dark text-xs"></i>
            <span className="text-cl-dark text-xs font-black uppercase tracking-widest">Cleario Services</span>
          </div>
          <h2 className="font-black text-cl-dark mb-3" style={{ fontSize: "clamp(1.8rem, 3.5vw, 2.8rem)" }}>
            Our most popular services
          </h2>
          <p className="text-cl-dark/55 text-base font-semibold max-w-lg mx-auto">
            We&apos;re on stand-by to help with any queries above, if you&apos;re ready to order here&apos;s our most used services.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {popularServices.map((service) => (
            <Link
              key={service.title}
              to={service.href}
              className="group flex items-center gap-4 bg-white rounded-2xl p-4 thick-border cartoon-shadow-sm hover:cartoon-shadow transition-all cursor-pointer"
            >
              <div
                className="w-20 h-20 flex items-center justify-center rounded-xl overflow-hidden flex-shrink-0"
                style={{ background: service.imageBg }}
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="flex-1 min-w-0">
                <span
                  className={`inline-block text-[10px] font-black px-2.5 py-0.5 rounded-full mb-1.5 ${service.badgeStyle}`}
                  style={{ border: "1.5px solid rgba(0,0,0,0.10)" }}
                >
                  {service.badge}
                </span>
                <p className="text-cl-dark font-black text-sm leading-tight mb-0.5">{service.title}</p>
                <p className="text-cl-green font-black text-sm">{service.price}</p>
              </div>
              <span className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-xl bg-cl-lime thick-border group-hover:bg-cl-green transition-colors">
                <i className="ri-arrow-right-line text-cl-dark group-hover:text-white text-sm transition-colors"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
